var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 8.66664C11.3334 12 9.00002 13.6666 6.22669 14.6333C6.08146 14.6825 5.92371 14.6802 5.78002 14.6266C3.00002 13.6666 0.666687 12 0.666687 8.66664V3.99997C0.666687 3.82316 0.736925 3.65359 0.861949 3.52857C0.986974 3.40355 1.15654 3.33331 1.33335 3.33331C2.66669 3.33331 4.33335 2.53331 5.49335 1.51997C5.63459 1.39931 5.81426 1.33301 6.00002 1.33301C6.18578 1.33301 6.36545 1.39931 6.50669 1.51997C7.67335 2.53997 9.33335 3.33331 10.6667 3.33331C10.8435 3.33331 11.0131 3.40355 11.1381 3.52857C11.2631 3.65359 11.3334 3.82316 11.3334 3.99997V8.66664Z",
    stroke: "#E17954",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.7045b77326ab2a1279ed2ce543509875.svg";
export { ForwardRef as ReactComponent };